import DonationBox from '../components/DonationSelector';

const FrontendApp = () => {
  	return (
      	<DonationBox />
  	);
};

export default FrontendApp;

